"use client";
import t from "./index.es59.js";
import e from "react";
import n from "./index.es20.js";
const r = t.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`, i = () => /* @__PURE__ */ e.createElement(r, null, /* @__PURE__ */ e.createElement(n, null));
export {
  i as default
};
//# sourceMappingURL=index.es19.js.map
